declare const oneTrustTV: any;

/**
 * Get the one trust status as a promise
 *
 * @param purposeId
 * @returns
 */
export const getPurposeConsentStatus = (purposeId): Promise<{ id: string; consent: number }> => {
  return new Promise((resolve, reject) => {
    oneTrustTV.getPurposeConsentStatus(purposeId, (error, status) => {
      if (error) {
        reject(error);
      } else if (status.length > 0) {
        resolve(status[0]);
      } else {
        reject(new Error('status empty'));
      }
    });
  });
};
